/**
 * TanStack Query hooks for `igaming-player-registration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingPlayerRegistrationQueryKeys,
	type CreateIgamingPlayerRegistrationBody,
	type ListIgamingPlayerRegistrationResponse,
	type IgamingPlayerRegistrationRow,
} from "./api";

export function useIgamingPlayerRegistrationList(): UseQueryResult<ListIgamingPlayerRegistrationResponse, Error> {
	return useQuery({
		queryKey: igamingPlayerRegistrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingPlayerRegistrationCreate(): UseMutationResult<IgamingPlayerRegistrationRow, Error, CreateIgamingPlayerRegistrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingPlayerRegistrationQueryKeys.all });
		},
	});
}

export function useIgamingPlayerRegistrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingPlayerRegistrationQueryKeys.all });
		},
	});
}
